import React from "react";
import { Navigate } from "react-router-dom";
import Loader from "../components/Loader";

export default function ProtectedRoute({ user, loading, isUnauthorized, children }) {
  if (loading) return <Loader />;
  if (!user && isUnauthorized) return <Navigate to="/unauthorized" replace />;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
